import { render, staticRenderFns } from "./FormEditor.vue?vue&type=template&id=4959ca32&scoped=true&"
import script from "./FormEditor.vue?vue&type=script&lang=js&"
export * from "./FormEditor.vue?vue&type=script&lang=js&"
import style0 from "./FormEditor.vue?vue&type=style&index=0&id=4959ca32&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4959ca32",
  null
  
)

export default component.exports